module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-1"
  }, [_c('div', {
    staticClass: "person-block clearfix"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.person.loading),
      expression: "person.loading"
    }],
    staticClass: "mv20 text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.person.loading),
      expression: "!person.loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [(_vm.person.image && _vm.person.image.url) ? _c('img', {
    staticClass: "img-rounded wp100",
    attrs: {
      "src": _vm.person.image.url
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "f18 bold mt10"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.person.name) + "\n\n\t\t\t\t\t")]), _vm._v(" "), (_vm.person.title) ? _c('div', {
    staticClass: "mv10 f16",
    domProps: {
      "innerHTML": _vm._s(_vm.titleHtml)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.person.phone) ? _c('div', {
    staticClass: "mv10 f14"
  }, [_vm._v("\n\t\t\t\t\t\t电话：" + _vm._s(_vm.person.phone) + "\n\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.person.office) ? _c('div', {
    staticClass: "mv10"
  }, [_vm._v("\n\t\t\t\t\t\t办公地点：" + _vm._s(_vm.person.office) + "\n\n\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.person.email) ? _c('div', {
    staticClass: "mv10"
  }, [_vm._v("\n\t\t\t\t\t\t邮件：" + _vm._s(_vm.person.email) + "\n\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), (_vm.person.description) ? _c('div', {
    staticClass: "col-xs-12 mt10 mb40"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.person.description)
    }
  })]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2113e209"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/person/widget/PersonBlock.vue
// module id = 960
// module chunks = 1